import * as React from "react";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar, { AvatarProps } from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";

export interface AvatarInterface extends AvatarProps {
  size?: number;
  id?: string;
  onEdit?: () => void;
}

const StyledAvatar = styled(Avatar)(({ theme }: any) => ({
  border: `2px solid ${theme.palette.common["borderGrey"]}`,
}));

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "iconSize",
  name: "Button",
})<{ iconSize?: number; theme?: any }>(({ iconSize = 60, theme }) => ({
  width: iconSize ? iconSize / 3 : iconSize,
  height: iconSize ? iconSize / 3 : iconSize,
  minWidth: 25,
  minHeight: 25,
  borderRadius: "50px",
  border: `1px solid ${theme.palette.common["borderGrey"]}`,
  backgroundColor: theme.palette.common["white"],
  fontSize: theme.typography.body1.fontSize,
  "&:hover": {
    backgroundColor: theme.palette.common["white"],
  },
}));

const AvatarWithEdit = ({
  size = 60,
  onEdit,
  id,
  ...props
}: AvatarInterface) => {
  const avatar = (
    <StyledAvatar
      {...props}
      sx={{
        width: size,
        height: size,
      }}
    />
  );
  if (!onEdit) {
    return avatar;
  }
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      badgeContent={
        <StyledIconButton
          id={`avataredit-${id}`}
          onClick={onEdit}
          iconSize={size}
        >
          <i className="far fa-pen"></i>
        </StyledIconButton>
      }
    >
      {avatar}
    </Badge>
  );
};

export default AvatarWithEdit;
